import React from 'react';
import { ZoomIn, ZoomOut, Grid3x3, Maximize2, Plus, ChevronLeft, ChevronRight, FileText, SplitSquareVertical, Ruler } from 'lucide-react';

export function CanvasToolbar({
  zoomPercent, onZoomChange, fitToWidth,
  showGrid, onToggleGrid,
  snapSize, onSnapChange,
  localShowRulers, toggleRulers,
  dimsLabel, pageW, pageH,
  showPageNav, setShowPageNav,
  pages, activePageIndex, onPageChange,
  onAddPage, onInsertPageBreak,
}) {
  return (
    <div className="flex items-center gap-2 px-4 py-2 border-b border-border/30 bg-background/50 flex-shrink-0">
      <button onClick={() => onZoomChange(Math.max(25, zoomPercent - 10))} className="p-1 rounded hover:bg-muted/30 text-muted-foreground hover:text-foreground" title="Zoom out">
        <ZoomOut className="w-3.5 h-3.5" />
      </button>
      <span className="text-[10px] text-muted-foreground w-10 text-center">{zoomPercent}%</span>
      <button onClick={() => onZoomChange(Math.min(200, zoomPercent + 10))} className="p-1 rounded hover:bg-muted/30 text-muted-foreground hover:text-foreground" title="Zoom in">
        <ZoomIn className="w-3.5 h-3.5" />
      </button>
      <button onClick={fitToWidth} className="p-1 rounded hover:bg-muted/30 text-muted-foreground hover:text-foreground" title="Fit to width">
        <Maximize2 className="w-3.5 h-3.5" />
      </button>

      <div className="w-px h-4 bg-border/30 mx-1" />

      <button onClick={onToggleGrid} className={`p-1 rounded ${showGrid ? 'bg-primary/15 text-primary' : 'text-muted-foreground hover:text-foreground hover:bg-muted/30'}`} title="Toggle snap grid">
        <Grid3x3 className="w-3.5 h-3.5" />
      </button>
      <select value={snapSize || 0} onChange={e => onSnapChange(Number(e.target.value))} className="h-6 text-[9px] bg-muted/20 border border-border/30 rounded px-1 text-foreground outline-none">
        <option value={0}>No snap</option>
        <option value={8}>8px grid</option>
        <option value={16}>16px grid</option>
        <option value={24}>24px grid</option>
      </select>

      <button onClick={toggleRulers} className={`p-1 rounded ${localShowRulers ? 'bg-primary/15 text-primary' : 'text-muted-foreground hover:text-foreground hover:bg-muted/30'}`} title={localShowRulers ? 'Hide rulers' : 'Show rulers'} data-testid="ruler-toggle">
        <Ruler className="w-3.5 h-3.5" />
      </button>

      <div className="w-px h-4 bg-border/30 mx-1" />

      <span className="text-[9px] text-muted-foreground">{dimsLabel}</span>
      <span className="text-[9px] text-muted-foreground/70">•</span>
      <span className="text-[9px] text-muted-foreground">{pageW}×{pageH}px</span>

      <div className="flex-1" />

      <div className="flex items-center gap-1.5">
        <button onClick={() => setShowPageNav(!showPageNav)} className={`p-1 rounded transition-colors ${showPageNav ? 'bg-primary/15 text-primary' : 'text-muted-foreground hover:text-foreground hover:bg-muted/30'}`} title={showPageNav ? 'Hide page navigator' : 'Show page navigator'}>
          <FileText className="w-3.5 h-3.5" />
        </button>
        <div className="w-px h-4 bg-border/30 mx-0.5" />
        <button onClick={() => onPageChange && onPageChange(Math.max(0, activePageIndex - 1))} disabled={activePageIndex === 0} className="p-1 rounded hover:bg-muted/30 text-muted-foreground hover:text-foreground disabled:opacity-30 disabled:cursor-not-allowed" title="Previous page">
          <ChevronLeft className="w-3.5 h-3.5" />
        </button>
        <span className="text-[10px] text-muted-foreground min-w-[50px] text-center">{activePageIndex + 1} / {pages.length}</span>
        <button onClick={() => onPageChange && onPageChange(Math.min(pages.length - 1, activePageIndex + 1))} disabled={activePageIndex === pages.length - 1} className="p-1 rounded hover:bg-muted/30 text-muted-foreground hover:text-foreground disabled:opacity-30 disabled:cursor-not-allowed" title="Next page">
          <ChevronRight className="w-3.5 h-3.5" />
        </button>
        <div className="w-px h-4 bg-border/30 mx-0.5" />
        <button onClick={onAddPage} className="p-1 rounded hover:bg-muted/30 text-muted-foreground hover:text-foreground" title="Add new page">
          <Plus className="w-3.5 h-3.5" />
        </button>
        {onInsertPageBreak && (
          <button onClick={onInsertPageBreak} className="p-1 rounded hover:bg-muted/30 text-muted-foreground hover:text-foreground" title="Insert page break">
            <SplitSquareVertical className="w-3.5 h-3.5" />
          </button>
        )}
      </div>
    </div>
  );
}
